export const SEARCH_TYPES = {
  BASIC_SEARCH: 'basic_search',
  ENFORCEMENT_EXPLORER_SEARCH: 'enforcement_explorer_search',
  ADVANCED_SEARCH: 'advanced_search',
  JURISDICTION_ANAYLYZER_SEARCH: 'jurisdiction_analyzer_search'
};
